import { EMPTY_MAP } from "app/app.constants";
import { ACTIONS } from "features/planner/planner.constants";

const initialState = EMPTY_MAP;

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.WEBSOCKET_OPEN: {
      if (action.error) return state;

      const { viewId } = action;

      return state.setIn([viewId.toString(), "webSocket"], action.payload);
    }

    case ACTIONS.WEBSOCKET_CLOSE: {
      if (action.error) return state;

      const { viewId } = action;

      return state.delete(viewId.toString());
    }

    case ACTIONS.WEBSOCKET_ERROR: {
      const { viewId } = action;

      return state.setIn([viewId.toString(), "webSocketDidError"], true);
    }

    default:
      return state;
  }
};
